import Model from "./base/model";

class nfe extends Model{
  resourceName() {
    return "nfes";
  }

  fields() {
    return {
      path: "",
      name: "",
      number: "",
      receipt_id: "",
      receipt_path: "",
      receipt_name: "",
      fatura_id: "",
      fatura_path: "",
      fatura_name: "",
    }
  }

}

export default new nfe();
